import React, { useState } from "react";

interface Tab {
  key: string;
  label: string;
  count?: number;
}

interface PersistentTabsProps {
  tabs: Tab[];
  initialTab?: string;
  tabData: Record<string, any>;
  isLoading?: boolean;
  onTabChange?: (key: string) => void;
}

const PersistentTabs: React.FC<PersistentTabsProps> = ({ tabs, initialTab, tabData, isLoading = false, onTabChange }) => {
  const [activeTab, setActiveTab] = useState(initialTab || tabs[0].key);
  const [localTabData, setLocalTabData] = useState(tabData);

  React.useEffect(() => {
    if (!isLoading) {
      setLocalTabData(tabData);
    }
  }, [tabData, isLoading]);

  const handleTabClick = (key: string) => {
    setActiveTab(key);
    if (onTabChange) onTabChange(key);
  };

  return (
    <div className="flex gap-4">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => handleTabClick(tab.key)}
          className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors duration-150 ${
            activeTab === tab.key ? "text-text-primary border-text-primary" : "text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300"
          }`}
        >
          {tab.label}
          {typeof localTabData[tab.key]?.count === "number" && <span className="text-xs px-0.5 py-0.5">{`(${localTabData[tab.key].count})`}</span>}
        </button>
      ))}
    </div>
  );
};

export default PersistentTabs;
